/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { Observable, tap } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { EncryptionService } from '../../services/encryption.service';
import { isPlatformBrowser } from '@angular/common';

dayjs.extend(utc);
dayjs.extend(tz);

@Injectable({
  providedIn: 'root'
})
export class SetInterceptor implements HttpInterceptor {
  private selectedLanguage: string = 'en';
  private apiEndpoints = ['/userPackages', '/packages'];
  constructor(
    private _authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleRequest(req: HttpRequest<any>) {
    const storageKey = localStorage.getItem(environment.storageKey);
    const token: string | null = storageKey ? storageKey : null;
    const settings = localStorage.getItem('webSettings');
    if (isPlatformBrowser(this.platformId)) {     
      this.selectedLanguage = String(localStorage.getItem('lang'));
    }

    let provider = '';
    if (settings) {
      try {
        const parsedSettings = JSON.parse(settings);
        if (parsedSettings?.buzzDetails?.buzzEnabled && parsedSettings.buzzDetails.buzzId) {
          provider = 'buzz';
        }
      } catch (e) {
      // Invalid JSON, skip
      }
    }


    // eslint-disable-next-line @typescript-eslint/no-explicit-any, prefer-const
    let authReq: any;
    const headers: any = {
      authorization: token ? `Bearer ${token}` : '',
      // date: dayjs.default().valueOf().toString(),
      lang: this.selectedLanguage ? this.selectedLanguage : 'en',
      'content-language': this.selectedLanguage ? this.selectedLanguage : 'en',
      'x-portal': 'web',
      ...(provider && { provider })
    };

    // allowed multiplart form data
    // if (!req.url.includes('/media/uploadFile') || !(req.body instanceof FormData)) {
    //   headers['Content-Type'] = 'application/json';
    // }
    if(!(req.body instanceof FormData)){
       headers['Content-Type'] = 'application/json';
    }

    if (req.url.includes('user/resetPassword')) {
      this._authService.resetTokenSubject.subscribe((res: string) => {
        if (res) {
          headers.authorization = `Bearer ${res}`;
        }
      });
    }

    const profile = this._authService.profileDetailsSubject.getValue();
    const query: any = {};
    if (!this.isApiAllowed(req.url) && profile && !req.url.includes('lms') && !req.url.includes('categories') && !req.url.includes('knowledgebank/generate')) {
      query['role'] = profile.role;
    }
    // eslint-disable-next-line prefer-const
    authReq = req.clone({
      headers: new HttpHeaders({
        // hash: this._encryptionSerivce.encryptHeaders(headers),
        ...headers,
        deviceType: 'web',
        lang: this.selectedLanguage ? this.selectedLanguage : 'en',
        'content-language': this.selectedLanguage ? this.selectedLanguage : 'en'
      }),
      setParams: {
        ...query
      }
    });

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put' ||
      req.method.toLowerCase() === 'delete'
    ) {
      if (req.url.includes('/admin/media')) {
        // Do nothing
      } 
    }
    return authReq;
  }

  isApiAllowed(fullUrl: string): boolean {
    try {
    // Ensure absolute URL
      const absoluteUrl = fullUrl.startsWith('http') ? fullUrl : `${window.location.origin}/${fullUrl.replace(/^\/+/, '')}`;

      const url = new URL(absoluteUrl);
      const apiEndpoint = url.pathname;

      return this.apiEndpoints.some((endpoint: string) => apiEndpoint === endpoint || apiEndpoint.startsWith(`${endpoint}/`)
      );
    } catch (error) {
      return false;
    }
  }


}
